import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCancel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeWidth: 1.5,
		d: "M1.25 12C1.25 6.08579 6.08579 1.25 12 1.25C17.9142 1.25 22.75 6.08579 22.75 12C22.75 17.9142 17.9142 22.75 12 22.75C6.08579 22.75 1.25 17.9142 1.25 12ZM12 2.75C6.91421 2.75 2.75 6.91421 2.75 12C2.75 17.0858 6.91421 21.25 12 21.25C17.0858 21.25 21.25 17.0858 21.25 12C21.25 6.91421 17.0858 2.75 12 2.75ZM15.3603 8.63965C15.6531 8.93255 15.6531 9.40742 15.3603 9.70031L13.0606 12L15.3603 14.2997C15.6531 14.5925 15.6531 15.0674 15.3603 15.3603C15.0674 15.6532 14.5925 15.6532 14.2996 15.3603L11.9999 13.0606L9.70025 15.3603C9.40736 15.6532 8.93249 15.6532 8.63959 15.3603C8.3467 15.0674 8.3467 14.5925 8.63959 14.2997L10.9393 12L8.63959 9.70031C8.3467 9.40742 8.3467 8.93255 8.63959 8.63965C8.93249 8.34676 9.40736 8.34676 9.70025 8.63965L11.9999 10.9393L14.2996 8.63965C14.5925 8.34676 15.0674 8.34676 15.3603 8.63965Z",
		fill: "black"
	})
});
export default SvgCancel;
